<template>
  <div v-if="navigation">
    <h3>Footer Menu編輯</h3>
    <div class="h4 py-5">僅提供文案編輯修改</div>
    <div class="form-item d-flex h-64px align-center"
         v-for="item in navigation.footer_menu"
         :key="item.key">
      <label :for="`navitation-header-${item.key}`" class="w-174px mr-6">
        <h4 class="h4">{{ item.key }}</h4>
      </label>
      <div class="form-input-group flex-grow-1">
        <input type="text" :id="`navitation-header-${item.key}`" v-model="item.val"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navigation: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style></style>
